'use strict';

module.exports = Object.freeze(['consumer', 'business']);
